import React from "react";

export default function WizardNavigation({

    step,

    total,

    saving,

    onBack,

    onNext,

    onFinish

}) {

    return (

        <div
            style={{

                display: "flex",

                justifyContent: "space-between",

                alignItems: "center",

                marginTop: 40,

                borderTop: "1px solid #eee",

                paddingTop: 24

            }}
        >

            <button

                onClick={onBack}

                disabled={step === 1}

                style={{

                    padding: "12px 26px",

                    borderRadius: 12,

                    border: "1px solid #ddd",

                    background:

                        step === 1

                            ? "#f5f5f5"

                            : "#fff",

                    cursor:

                        step === 1

                            ? "not-allowed"

                            : "pointer",

                    fontWeight: 600

                }}

            >

                ? Back

            </button>

            <div
                style={{

                    fontSize: 14,

                    color: "#777",

                    fontWeight: 500

                }}
            >

                Step {step} of {total}

            </div>

            {step < total ? (

                <button

                    onClick={onNext}

                    style={{

                        padding: "12px 26px",

                        border: "none",

                        borderRadius: 12,

                        background:
                            "#4F46E5",

                        color: "#fff",

                        fontWeight: 600,

                        cursor: "pointer"

                    }}

                >

                    Continue ?

                </button>

            ) : (

                <button

                    onClick={onFinish}

                    disabled={saving}

                    style={{

                        padding: "12px 32px",

                        border: "none",

                        borderRadius: 12,

                        background:
                            saving
                                ? "#A5B4FC"
                                : "#16A34A",

                        color: "#fff",

                        fontWeight: 700,

                        cursor:

                            saving

                                ? "wait"

                                : "pointer"

                    }}

                >

                    {saving

                        ? "Creating Brand..."

                        : "Create Brand"}

                </button>

            )}

        </div>

    );

}